import { Box } from "@mui/material";
import styled from "styled-components";
import { thirdly2 } from "styles/theme";
import { thirdly } from "styles/theme";
import { white, header, sidebar } from "styles/theme";
import { styled as muiStyled } from '@mui/material/styles';
import { ScrollCss } from "styles/GlobalCss";
import { display } from "@mui/system";
import { dark } from "styles/theme";
import { thirdly4 } from "styles/theme";
import { textDisabled } from "styles/theme";

export const BackAndNextAppStyles = muiStyled(Box)(({ theme, $systemUI, len, index }) => ({
    display: "flex",
    columnGap: 15,
    alignItems: "center",
    '.app-buttons': {
        display: "flex",
        height: 33,
        background: thirdly4,
        padding: 4,
        borderRadius: 18.5,
        alignItems: "center",
        boxSizing: "border-box",
        padding: 10,
        borderRadius: 18.5
    },
    // פניה ישירה לכפתור כשהוא במצב disabled
    '.MuiIconButton-root.Mui-disabled': {
        '.app-icon': {
            color: textDisabled // שימוש בצבע ה-disabled של המערכת
        }
    },
    '.app-icon': {
        fontSize: 16,
        color: dark
    },
    '.right-icon': {
    },
    '.refresh-icon': {
    },
    '.MuiButtonBase-root.MuiIconButton-root': {
        background: thirdly4,
        width: 33,
        height: 33
    }
}));

const WrapHeaderStyles = muiStyled(Box)(({ theme, $systemUI, len, index, headerHeight }) => ({
    height: headerHeight,
    padding: 10,
    background: white,
    position: "absolute",
    top: 0,
    display: "flex",
    alignItems: "center",
    columnGap: 15,
    width: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
    ...ScrollCss,
    borderBottom: `1px solid ${thirdly2}`,
    boxSizing: "border-box",
    '.advanced-btn': {
        width: 150
    },
    [theme.breakpoints.down('md')]: {
        paddingLeft: 80
    },
    '.header-pulldowns': {
        flexGrow: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        rowGap: 5
    },
    '.create-ticket-btn': {
        width: 215,
    }
}));


const WrapPullDown = styled.div`
`

const WrapContent = muiStyled(Box)(({ hidden, theme, $systemUI, len, index }) => ({
    marginLeft: `${sidebar + 10}px`,
    display: "flex",
    columnGap: 10,
    alignItems: "center",
    overflowX: "auto",
    overflowY: "hidden",
    [theme.breakpoints.down('md')]: {
        marginLeft: 0
    },
    '.filters': {
        display: hidden ? "none" : "flex",
        columnGap: 10,
        alignItems: "center",
        overflowX: "auto",
        padding: "6px 0px"
    }
}));

export { WrapHeaderStyles, WrapPullDown, WrapContent }